export * from "./truncated-text";
